(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-product-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-product-atc')) {
    customElements.define('sticky-product-atc', class StickyProductAtc extends HTMLElement {
      connectedCallback() {
        this.main = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
        this.form = document.getElementById(`product-form-${this.dataset.sectionId}`);
        this.sourceButton = this.form?.querySelector('[name="add"]');
        if (!this.main || !this.sourceButton) return;

        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-sticky-label]');
        this.price = this.querySelector('[data-sticky-price]');
        this.compare = this.querySelector('[data-sticky-compare]');
        this.compareLabel = this.querySelector('[data-sticky-compare-label]');
        this.mobilePrices = this.querySelector('[data-sticky-mobile-prices]');
        this.mobilePrice = this.querySelector('[data-sticky-mobile-price]');
        this.mobileCompare = this.querySelector('[data-sticky-mobile-compare]');
        this.error = this.querySelector('[role="alert"]');
        this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
        this.sourcePrice = document.getElementById(`price-${this.dataset.sectionId}`);
        this.footer = document.querySelector('#shopify-section-footer') || document.querySelector('footer');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateVisibility();
          });
        };

        this.button.addEventListener('click', () => {
          this.sync();
          if (this.button.disabled) return;
          this.submitted = true;
          this.form.requestSubmit(this.sourceButton);
          this.sync();
        }, options);
        this.main.addEventListener('change', () => this.sync(), options);
        window.addEventListener('scroll', this.schedule, { ...options, passive: true });
        window.addEventListener('resize', this.schedule, options);
        window.addEventListener('pageshow', this.schedule, options);
        this.observer = new MutationObserver(() => {
          this.sync();
          this.schedule();
        });
        this.observer.observe(this.main, { subtree: true, childList: true, characterData: true, attributes: true });
        this.intersections = new IntersectionObserver(this.schedule);
        this.intersections.observe(this.sourceButton);
        this.main.querySelectorAll('.product-purchase-controls, .product-form__buttons, .product-form__quantity').forEach(control => {
          this.intersections.observe(control);
        });
        if (this.footer) this.intersections.observe(this.footer);
        this.sync();
        this.schedule();
      }

      sync() {
        const busy = this.sourceButton.classList.contains('loading');
        this.button.disabled = this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
        this.button.setAttribute('aria-busy', String(busy));
        this.label.textContent = this.sourceButton.querySelector('span')?.textContent.trim() || this.label.textContent;
        const popup = this.sourceButton.getAttribute('aria-haspopup');
        if (popup) this.button.setAttribute('aria-haspopup', popup);

        const variant = this.variants[this.form.querySelector('[name="id"]').value];
        let price = variant?.price || '';
        let compare = variant?.compare || '';
        const source = this.sourcePrice?.querySelector('.price');
        if (source) {
          const sale = source.classList.contains('price--on-sale');
          const offer = source.querySelector('.price-item--rakhi-offer');
          price = (offer || source.querySelector(sale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular'))?.textContent.trim() || price;
          compare = (offer ? source.querySelector('.price-item--rakhi-reference') : sale ? source.querySelector('.price__sale s') : null)?.textContent.trim() || '';
        }
        this.price.textContent = price;
        this.compare.textContent = compare;
        this.compare.hidden = !compare;
        this.compareLabel.hidden = !compare;
        this.price.parentElement.hidden = this.sourcePrice?.classList.contains('visibility-hidden') || !price;
        this.mobilePrice.textContent = price;
        this.mobileCompare.textContent = compare;
        this.mobileCompare.hidden = !compare;
        this.mobilePrices.hidden = this.price.parentElement.hidden;

        const sourceError = this.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
        const message = this.submitted && sourceError && !sourceError.hidden ? sourceError.querySelector('.product-form__error-message')?.textContent.trim() : '';
        if (this.error.textContent !== (message || '')) this.error.textContent = message || '';
        this.error.hidden = !message;
      }

      updateVisibility() {
        const buttonRect = this.sourceButton.getBoundingClientRect();
        const footerVisible = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight;
        let visible = window.scrollY > 0 && buttonRect.height > 0 && buttonRect.bottom <= 0 && !footerVisible;
        if (window.innerWidth < 750) {
          const controls = [this.sourceButton, ...this.main.querySelectorAll('.product-purchase-controls, .product-form__buttons, .product-form__quantity')];
          const controlsVisible = controls.some(control => {
            const rect = control.getBoundingClientRect();
            return rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
          });
          visible = buttonRect.height > 0 && !controlsVisible;
        }
        if (!visible && this.contains(document.activeElement)) this.sourceButton.focus({ preventScroll: true });
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', String(!visible));
        this.inert = !visible;
      }

      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.intersections?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
